/*
 * Copyright (C) 2018 Bruno López Trigo
 * 
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React, { Component, Fragment } from "react";
import NavBar from "../components/global/NavBar";
import {
  Grid,
  Paper,
  CircularProgress,
  Typography,
  ExpansionPanelDetails,
  ExpansionPanel,
  ExpansionPanelSummary,
  ListItemIcon,
  Chip,
  ListItem,
  ListItemText,
  List, CardHeader
} from "@material-ui/core";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Redirect } from "react-router-dom";
import {
  buildSomeClassifier, buildSomeModels, deleteDataset,
  getConfig,
  getDataset, getSomeClassifications,
  getSomeExplanations,
  getSomeTree,
  getTest, uploadDataset, uploadDatasetScratch
} from "../components/global/API";
import CustomizedSnackbars from "../components/global/CustomizedSnackbars";
import "react-select/dist/react-select.css";
import "react-virtualized/styles.css";
import "react-virtualized-select/styles.css";
import {
  ExpandMore as ExpandMoreIcon,
  SentimentSatisfied as Medium, SentimentVeryDissatisfied as Low,
  SentimentVerySatisfied as High
} from "@material-ui/icons";
import IconButton from "@material-ui/core/IconButton";
import StepperSimple from "../components/global/StepperSimple";
import Popup from "reactjs-popup";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import tree1 from "../components/images/tree1.jpg";
import tree2 from "../components/images/tree2.jpg";
import tree3 from "../components/images/tree3.jpg";
import rules from "../components/images/rules1.jpg";
import rulesTree from "../components/images/rules_tree.jpg";
import forest from "../components/images/forest.jpg";
import CardContent from "@material-ui/core/CardContent";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import InfoIcon from '@material-ui/icons/InfoOutlined';
import Link from "@material-ui/core/Link";
import galicia from "../components/images/galicia.png";
import usc from "../components/images/usc.png";
import campusVida from "../components/images/campusvida.png";
import ue from "../components/images/ue.png";
import xunta from "../components/images/xunta.png";
import ConfigurationPanelSimple from "../components/classifiers/ConfigurationPanelSimple";
import Tree from "../components/classifiers/Tree";
import AlternativesSelect from "../components/classifiers/AlternativesSelect";
import Rules from "../components/classifiers/Rules";
import xacobeo from "../components/images/xacobeo-color-original.jpg";
import citius_horizontal from "../components/images/citius_horizontal.png";


const styles = theme => ({
  paperRight: {
    padding: 10,
    margin: 5,
    height: "100%",
    minHeight: "500px",
    display: "flex",
    flexDirection: "column"
  },
  upper: {
    marginTop: 20,
    textTransform: "uppercase",
    color: "#283593"
  },
  root: {
    marginBottom:100,
    marginTop:60,
    display:"block"
  },
  progress: {
    margin: "auto",
    marginTop: 80,
    marginBottom: 30
  },
  loader: {
    marginTop: 80,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    justifyItems: "center"
  },
  plainLogBox:{
    margin:"5px",
    width:"50%",
    padding:"5px",
    backgroundColor: "#fafafa",
    border: "2px solid #ccc",
    display: "inline-block",
    textAlign:"left",
    overflow:"scroll",
    [theme.breakpoints.down("lg")]: {
      width:"90%"
    },
  },
  plainLogBoxContenedor:{
    textAlign: "center",
    overflow:"scroll",
  },
  chipHigh: {
    fontSize: 16,
    backgroundColor: "#4caf50",
    margin: 5,
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  chipMedium: {
    fontSize: 16,
    backgroundColor: "#ffa000",
    margin: 5,
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  chipLow: {
    fontSize: 16,
    backgroundColor: "#f4511e",
    margin: 5,
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  buttonDownload:{
    position:"relative",
    top:"0",
    right:"0"
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200,
  },
  select: {
    width: "100%",
    padding: 10,
    fontFamily: "Roboto"
  },
  button:{
    width:"100%",
    padding: 10,
    marginTop:50
  },
  expansionPanelDetails: {
    display: "block"
  },
  footer:{
    boxShadow: "0px 2px 4px -1px rgba(0, 0, 0, 0.2),0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
    display:"inline-table",
    justifyContent:"space-evenly",
    position:"fixed",
    bottom:0,
    height:100,
    left:0,
    width:"100%",
    backgroundColor:"white",
  },
  centerFotter:{
    display:"flex",
    justifyContent:"space-evenly",
  },
  leftLogos: {
    height: 36,
    marginTop: 20,
    marginBottom: 20
  },
  rightLogos: {
    height: 60,
    marginTop: 20,
    marginBottom: 20
  },
});

class ClassifierPanelAll extends Component {
  constructor(props) {
    super(props);
    this.state = {
      algorithm: this.props.algorithm,
      loading: true,
      loadingConfig:true,
      typesOfInstances:[{value: 0, label: "Test " },{value: 1, label: "Train" }],
      typeInstanceSelected:0,
      selectedTestInstance:0,
      selectedInstance:0,
      FURIAparams: {
        tnorm: 0,
        batchSize: 100,
        checkErrorRate: true,
        doNotCheckCapabilities: false,
        folds: 3,
        minNo: 2,
        numDecimalPlaces: 2,
        optimizations: 2,
        seed: 1,
        uncovAction: 0
      },
      HTparams: {
        fuzzyCardinality: true,
        fuzzySets: 3,
        propertyLabels:"L1,L2,L3",
        centroids: "0.5",
        gracePeriod: 25.0,
        hoeffdingTieThreshold: 2.5,
        leafPredictionStrategy:0,
        minimumFractionOfWeightInfoGain: 0.01,
        naiveBayesPredictionThreshold: 0.0,
        numDecimalPlaces: 2,
        printLeafModels: false,
        admitRepetitions:false,
        splitConfidence: 1.0e-7,
        splitCriterion:1
      },
      J48params: {
        binarySplits: false,
        collapseTree: true,
        doNotMakeSplit: false,
        confidenceFactor: 0.25,
        minNumObj: 2,
        numFolds: 3,
        reduceError: false,
        seed: 1,
        subtreeRaising: true,
        unpruned: false,
        useLaplace: false,
        useMDL: true
      },
      Randomparams: {
        valueK: 0,
        minNumObj: 1,
        minVarianceProp: 0.001,
        seed: 1,
        maxDepth: 0,
        numFolds: 0,
        allowUnclassified: false,
        breakTies: false,
        numDecimalPlaces: 2
      },
      REPparams: {
        noCheckCapabilities: false,
        initialCount: 0,
        maxDepth: -1,
        minNumObj: 2,
        minVarianceProp: 0.001,
        noPruning: false,
        numDecimal: 2,
        numFolds: 3,
        seed: 1,
        spreadInitialCount: false
      },
      RandomForestParams: {
        bagSizePercent: 100,
        batchSize: 100,
        breakTiesRandomly: false,
        calcOutOfBag: false,
        completeAttributeImportance: false,
        debug:false,
        doNotCheckCapabilities: false,
        maxDepth:0,
        numDecimalPlaces: 2,
        numExecutionSlots: 1,
        numFeatures: 0,
        numIterations:100,
        outputOutOfBagComplexityStatistics:false,
        printClassifiers:false,
        seed:1,
        storeOutOfBagPredictions:false,
      },
    };
  this.changeLock = this.changeLock.bind(this);
  this.gotoComparation = this.gotoComparation.bind(this);
  this.goToInitial = this.goToInitial.bind(this);
  this.updateLocalExplanation = this.updateLocalExplanation.bind(this);
  this.updateTree = this.updateTree.bind(this);
  this.changeAlternative = this.changeAlternative.bind(this);
  this.selectInstanceChange = this.selectInstanceChange.bind(this);
  this.selectInstanceChangeTest = this.selectInstanceChangeTest.bind(this);
  }

  async componentDidMount() {
    console.log(this.props.dataset)
    if(this.props.dataset ==="new") {
      this.buildClassifierPromise();
    }else if(this.props.dataset ==="newScratch"){
      this.buildClassifierPromiseScratch();
    }else{
      Promise.all([this.getConfig(this.props.dataset), this.getSomeGlobalExplanation(this.props.dataset), this.getTree(this.props.dataset),this.getDataset(this.props.dataset)]).then(() => {
        this.setState({loading: false});
      });
    }
  }
  changeAlternative(alternativeIndexHT) {
    this.setState({ alternativeIndexHT });
  }
  updateTree(classificationsJ48,classificationsREPTree,classificationsRandomTree,classificationsFuzzyHoeffdingTree,classificationsFURIA, values, tolerance) {
    this.setState({ loading: true });
    console.log(classificationsFuzzyHoeffdingTree);
    console.log(classificationsJ48);
    var alternativesJ48 = [];
    var solutionsJ48 = [];

    var alternativesRandomTree = [];
    var solutionsRandomTree = [];

    var alternativesREPTree = [];
    var solutionsREPTree = [];

    var alternativesFuzzyHoeffdingTree = [];
    var solutionsFuzzyHoeffdingTree = [];

    classificationsJ48.map(classification => {
      alternativesJ48.push(classification.tree);
      solutionsJ48.push(classification.state);
      return true;
    });
    classificationsRandomTree.map(classification => {
      alternativesRandomTree.push(classification.tree);
      solutionsRandomTree.push(classification.state);
      return true;
    });
    classificationsREPTree.map(classification => {
      alternativesREPTree.push(classification.tree);
      solutionsREPTree.push(classification.state);
      return true;
    });
    classificationsFuzzyHoeffdingTree.map(classification => {
      alternativesFuzzyHoeffdingTree.push(classification.tree);
      solutionsFuzzyHoeffdingTree.push(classification.state);
      return true;
    });
    var message;
    var info;

    if (classificationsFURIA.uncovered) {
      info = true;
      if (classificationsFURIA.uncovAction === "stretch") {
        message = this.props.language.labels[this.props.language.id].stretch;
      } else if (rules.uncovAction === "frequent") {
        message = this.props.language.labels[this.props.language.id].frequent;
      } else {
        message = this.props.language.labels[this.props.language.id].abstain;
      }
    }

  console.log(solutionsFuzzyHoeffdingTree)
    this.setState(
        {
          info,
          message,
          alternativesJ48,
          alternativesRandomTree,
          alternativesREPTree,
          alternativesFuzzyHoeffdingDecisionTree:alternativesFuzzyHoeffdingTree,
          solutionsJ48,
          solutionsRandomTree,
          solutionsREPTree,
          solutionsFuzzyHoeffdingDecionTree:solutionsFuzzyHoeffdingTree,
          classificationsJ48,
          classificationsRandomTree,
          classificationsREPTree,
          classificationsFuzzyHoeffdingTree,
          alternativeIndex: 0,
          alternativeIndexHT:0,
          values,
          tolerance,
          loading:false,
          rulesFuria:classificationsFURIA,
        })
  }
  componentDidUpdate(prevProps,prevState) {
    if (prevProps.language.id !== this.props.language.id) {
      this.setState({ loading: true },
          async () => {
            if(this.props.dataset ==="new") {
              Promise.all([this.getConfig(this.props.datasetNewBeginner),this.getSomeGlobalExplanation(this.props.datasetNewBeginner), this.getTree(this.props.dataset), this.getDataset(this.props.datasetNewBeginner)]).then(() => {
                this.setState({loading: false});
              });
            }
            else if(this.props.dataset ==="new") {
              Promise.all([this.getConfig(this.props.datasetNewBeginner),this.getSomeGlobalExplanation(this.props.datasetNewBeginner), this.getTree(this.props.dataset), this.getDataset(this.props.datasetNewBeginner)]).then(() => {
                this.setState({loading: false});
              });
            }else{
              Promise.all([this.getConfig(this.props.dataset), this.getSomeGlobalExplanation(this.props.dataset), this.getTree(this.props.dataset), this.getDataset(this.props.dataset)]).then(() => {
                this.setState({loading: false});
              });
            }
      })
    }
    if(prevState.alternativesJ48 === undefined && (this.state.models!==undefined || (prevProps.dataset!=="new" && prevProps.dataset!=="newScratch"))){
      console.log('Update')
      if (this.props.dataset === "new") {
        this.getTree(this.props.datasetNewBeginner)
      } else if (this.props.dataset === "newScratch") {
        this.getTree(this.props.datasetNewBeginner)
      } else {
        this.getTree(this.props.dataset)
      }
    }
  }
  async buildClassifierPromise(){
          console.log(this.props.datasetNewBeginner)
          console.log(this.props.file)
          if(this.props.file===undefined){
            this.props.handleGlobalMessage(
                "error",
                this.props.language.labels[this.props.language.id].errorMessageNullFile
            );
            this.setState({
              redirect:true,
            })
          }else {
            var response = await uploadDataset(
                this.props.datasetNewBeginner,
                this.props.file,
                this.props.token
            );
            if (response.error) {
              if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                  loading: false,
                  redirect: true
                });
              } else {
                this.props.handleGlobalMessage(
                    "error",
                    response.data
                );
                this.setState({
                  loading: false,
                  redirect: true,
                  error: true,
                  message: response.data
                });
              }
            } else {
              this.setState(
                  {
                    dataset: response.data
                  },
                  async () => {
                    response = await buildSomeClassifier(
                        this.props.datasetNewBeginner,
                        true, true, true,
                        true, true, true,
                        this.state.J48params,
                        this.state.Randomparams,
                        this.state.REPparams,
                        this.state.FURIAparams,
                        this.state.HTparams,
                        this.state.RandomForestParams,
                        this.props.token
                    )
                    if (response.error) {
                      if (response.status === 401) {
                        this.props.handleGlobalMessage(
                            "error",
                            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                        );
                        this.props.closeSession();
                        this.setState({
                          loading: false,
                          redirect: true
                        });
                      } else {
                        await deleteDataset(this.state.name, this.props.token);
                        this.props.handleGlobalMessage(
                            "error",
                            response.message
                        );
                        this.setState({
                              loading: false,
                              error: true,
                              redirect: true,
                              message: response.data
                            },
                        );
                      }
                    } else {
                      this.setState({
                            classifier: response.data,
                          },
                          async () => {
                            response = await buildSomeModels(
                                this.props.datasetNewBeginner,
                                true, true, true,
                                true, true, true,
                                this.state.J48params,
                                this.state.Randomparams,
                                this.state.REPparams,
                                this.state.FURIAparams,
                                this.state.HTparams,
                                this.state.RandomForestParams,
                                this.props.token
                            );
                            if (response.error) {
                              if (response.status === 401) {
                                this.props.handleGlobalMessage(
                                    "error",
                                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                );
                                this.props.closeSession();
                                this.setState({
                                  loading: false,
                                  redirect: true
                                });
                              } else {
                                //await deleteDataset(this.state.name, this.props.token);
                                this.setState({
                                  loading: false,
                                  error: true,
                                  message: response.data
                                });
                              }
                            } else {
                              this.setState(
                                  {
                                    models: response.data,
                                    loadingConfig:false,
                                  },
                                  async () => {
                                    this.getConfig(this.props.datasetNewBeginner);
                                    this.getDataset(this.props.datasetNewBeginner);
                                    this.getSomeGlobalExplanation(this.props.datasetNewBeginner);
                                    this.getTree(this.props.datasetNewBeginner);
                                  }
                              );
                            }
                          });
                    }
                  }
              );
            }
          }
  }

  async buildClassifierPromiseScratch(){
    var response = await uploadDatasetScratch(
        this.props.datasetNewBeginner,
        this.props.file,
        this.props.token
    );
    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          loading: false,
          redirect: true
        });
      } else {
        this.props.handleGlobalMessage(
            "error",
            response.data
        );
        this.setState({
          loading: false,
          redirect:true,
          error: true,
          message: response.data
        });
      }
    } else {
      this.setState(
          {
            dataset: response.data
          },
          async () => {
            response = await buildSomeClassifier(
                this.props.datasetNewBeginner,
                true,true,true,
                true,true,true,
                this.state.J48params,
                this.state.Randomparams,
                this.state.REPparams,
                this.state.FURIAparams,
                this.state.HTparams,
                this.state.RandomForestParams,
                this.props.token
            )
            if (response.error) {
              if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                  loading: false,
                  redirect: true
                });
              } else {
                await deleteDataset(this.props.datasetNewBeginner, this.props.token);
                this.props.handleGlobalMessage(
                    "error",
                    response.data
                );
                this.setState({
                      loading: false,
                      redirect:true,
                      error: true,
                      message: response.data
                    },
                );
              }
            } else {
              this.setState({
                    classifier: response.data,
                  },
                  async () => {
                    response = await buildSomeModels(
                        this.props.datasetNewBeginner,
                        true,true,true,
                        true,true,true,
                        this.state.J48params,
                        this.state.Randomparams,
                        this.state.REPparams,
                        this.state.FURIAparams,
                        this.state.HTparams,
                        this.state.RandomForestParams,
                        this.props.token
                    );
                    if (response.error) {
                      if (response.status === 401) {
                        this.props.handleGlobalMessage(
                            "error",
                            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                        );
                        this.props.closeSession();
                        this.setState({
                          loading: false,
                          redirect: true
                        });
                      } else {
                        await deleteDataset(this.props.datasetNewBeginner, this.props.token);
                        this.setState({
                          loading: false,
                          redirect:true,
                          error: true,
                          message: response.data
                        });
                      }
                    } else {
                      this.setState(
                          {
                            loadingConfig:false,
                            models: response.data,
                          },
                          async () => {
                            this.getConfig(this.props.datasetNewBeginner);
                            this.getDataset(this.props.datasetNewBeginner);
                            this.getSomeGlobalExplanation(this.props.datasetNewBeginner);
                            this.getTree(this.props.datasetNewBeginner);
                          }
                      );
                    }
                  });
            }
          }
      );
    }
  }



  async getTree(name) {
    var response;
    console.log(this.state.values)
    if (this.state.values ) {
      response = await getSomeClassifications(
          name,
          this.props.language.id,
          0,
          this.state.values,
          this.props.token
      );

      var alternatives = [];
      var solutions = [];

      if (response.error) {
        if (response.status === 401) {
          localStorage.clear();
          this.props.handleGlobalMessage(
              "error",
              this.props.language.labels[this.props.language.id].errorMessageUnauthorized
          );
          this.setState({
            redirect: true
          });
        } else if (response.status === 404) {
          this.setState({
            error: true,
            redirect:true,
            message: response.data
          });
        } else {
          this.setState({
            error: true,
            redirect:true,
            message: response.data
          });
        }
      } else {
        response.data.map(classification => {
          alternatives.push(classification.tree);
          solutions.push(classification.state);
          return true;
        });

        this.setState({
          alternativeIndex: 0,
          alternativeIndexHT:0,
          alternatives,
          classifications: response.data,
          solutions
        });
      }
    } else {
      response = await getSomeTree(
          name,
          this.props.language.id,
          this.props.token
      );

      if (response.error) {
        if (response.status === 401) {
          localStorage.clear();
          this.props.handleGlobalMessage(
              "error",
              this.props.language.labels[this.props.language.id].errorMessageUnauthorized
          );
          this.setState({
            redirect: true
          });
        } else if (response.status === 404) {
          this.setState({
            error: true,
            redirect:true,
            message: response.data
          });
        } else {
          this.setState({
            error: true,
            redirect:true,
            message: response.data
          });
        }
      } else {
        this.setState({
          alternativeIndex: 0,
          alternativeIndexHT: 0,
          alternativesJ48: [response.data.treeJ48],
          solutionsJ48: [response.data.treeJ48.state],
          alternativesRandomTree: [response.data.treeRandomTree],
          solutionsRandomTree: [response.data.treeRandomTree.state],
          alternativesREPTree: [response.data.treeREPTree],
          solutionsREPTree: [response.data.treeREPTree.state],
          alternativesFuzzyHoeffdingDecisionTree: [response.data.treeHoeffdingTreeFuzzy],
          solutionsFuzzyHoeffdingDecionTree: [response.data.treeHoeffdingTreeFuzzy.state],
          rulesFuria:response.data.rulesFuria,
        });
      }
    }
  }


  async goToInitial(){
    this.setState({
      redirect:true,
    })
  }
  async getConfig(name) {
    console.log(name)
    var response = await getConfig(
        name,
        this.props.language.id,
        this.props.token
    );

    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          error: true,
          message: response.data
        });
      }
    } else {
      var maximo=0;
      for(var i=0;i<response.data.attributes.length;i++){
        if(response.data.attributes[i].name.length>maximo){
          maximo=response.data.attributes[i].name.length;
        }
      }
      console.log(response)
      this.setState(
          {
            maximo: maximo,
            config: response.data,
            isDefault:
                response.data.dataset === "beer" ||
                response.data.dataset === "glass" ||
                response.data.dataset === "wine" ||
                response.data.dataset === "iris" ||
                response.data.dataset === "flavia" ||
                response.data.dataset === "vehicle" ||
                response.data.dataset === "ACB" ||
                response.data.dataset === "PIMA" ||
                response.data.dataset === "OULAD" ||
                response.data.dataset === "bank" ,
            percentage: 5
          },
          async () => {
            this.getTest(name);
          }
      );
    }
  }
  async getSomeGlobalExplanation(name){
    var response = await getSomeExplanations(
        name,
        this.props.language.id,
        this.props.token
    );
    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          loading: false,
          redirect: true
        });
      } else {
        this.setState({
          loading: false,
          error: true,
          message: response.data
        });
      }
    } else {
      this.setState({
        loading:false,
        globalExplanationJ48: response.data.j48.clauses,
        percentageJ48:response.data.j48.precision.toFixed(2),
        globalExplanationREPTree: response.data.repTree.clauses,
        percentageREPTree:response.data.repTree.precision.toFixed(2),
        globalExplanationRandomTree: response.data.randomTree.clauses,
        percentageRandomTree:response.data.randomTree.precision.toFixed(2),
        globalExplanationFURIA: response.data.furia.clauses,
        percentageFURIA:response.data.furia.precision.toFixed(2),
        globalExplanationHoeffdingTreeFuzzy: response.data.htFuzzy.clauses,
        percentageHoeffdingTreeFuzzy:response.data.htFuzzy.precision.toFixed(2),
        globalExplanationRandomForest: response.data.randomForest.clauses,
        percentageRandomForest:response.data.randomForest.precision.toFixed(2),
      })
    }
  }
  async getDataset(name) {
    var response = await getDataset(
        name,
        this.props.token);

    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      }
      this.setState({
        error: true,
        message: response.data
      });
    } else {
      const labelsInstances = response.data.lines.map((instance, index) => ({
        value: index,
        label: "Instance " + (index + 1)
      }));

      this.setState({
        instances: response.data.lines,
        labelsInstances,
        selectedInstance: labelsInstances[0],
        instanceIndex: 0,
        instance: {
          attributes: response.data.lines[0].attributes,
          solution: response.data.lines[0].solution
        }
      });
    }
  }
async updateLocalExplanation(localExplanationJ48, localExplanationREPTree, localExplanationRandomTree, localExplanationRandomForest, localExplanationFURIA, localExplanationHoeffdingTreeFuzzy){
    this.setState({
      localExplanationJ48,
      localExplanationREPTree,
      localExplanationRandomTree,
      localExplanationRandomForest,
      localExplanationFURIA,
      localExplanationHoeffdingTreeFuzzy
    })
}
  async gotoComparation(){
    var values = await this.getValues();
    console.log("Valores")
    console.log(values)
    this.props.changeValues(values);
    this.setState({
      redirectComparation:true,
    })
  }
  async getTest(name) {
    var response = await getTest(
        name ,
        this.props.token);
    if (response.error) {
      if (response.status === 401) {
        this.props.handleGlobalMessage(
            "error",
            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
        );
        this.props.closeSession();
        this.setState({
          redirect: true
        });
      } else {
        this.setState({
          selected: "train"
        });
      }
    } else {
      const labelsTestInstances = response.data.lines.map(
          (instance, index) => ({
            value: index,
            label: "Instance " + (index + 1)
          })
      );

      this.setState({
        instancesTest: response.data.lines,
        labelsTestInstances,
        selectedTestInstance: labelsTestInstances[0],
        instanceTestIndex: 0,
        instance: {
          attributes: response.data.lines[0].attributes,
          solution: response.data.lines[0].solution
        }
      });
    }
  }
  selectInstanceChangeTest (number) {
    console.log("Change of instance test")
    this.setState({
      selectedTestInstance:number,
      instance: {
        attributes: this.state.instancesTest[number].attributes,
        solution: this.state.instancesTest[number].solution
      },
    })
  }
  selectInstanceChange(number){
    console.log("Change of instance")
    this.setState({
      selectedInstance:number,
      instance: {
        attributes: this.state.instances[number].attributes,
        solution: this.state.instances[number].solution
      },
    })
  }
  async changeLock()  {
    if(this.state.typeInstanceSelected === 0) {
      this.setState({
        typeInstanceSelected:1,
      })
    }else{
      this.setState({
        typeInstanceSelected:0,
      })
    }
  }
  async getValues(){
    console.log("Instance")
    console.log(this.state.instance)
    var values = { values: {} };
    console.log(Object.keys(this.state.instance.attributes).length)
    for (var i = 0; i < Object.keys(this.state.instance.attributes).length; i++) {
      values.values[this.state.instance.attributes[i + 1].id] = this.state.instance.attributes[i + 1].value;
      if(i===(Object.keys(this.state.instance.attributes).length)-1){
        console.log(values);
        return values;
      }
    }
  }


  render() {
    const { classes } = this.props;
    console.log(this.state.alternatives)
    return (
      <Fragment>
        <NavBar
          language={this.props.language}
          handleLanguageChange={this.props.handleLanguageChange}
        />
        <Grid container className={classes.root}>
          <Grid item xs={12} md={12} lg={12}>
            <Paper className={classes.paperRight}>
              {((this.props.dataset !=="new" && this.props.dataset !== "newScratch") || !this.state.loadingConfig) && !this.state.redirect &&
                <ConfigurationPanelSimple
                    dataset={this.props.dataset}
                    datasetNewBeginner={this.props.datasetNewBeginner}
                    algorithm={this.state.algorithm}
                    language={this.props.language}
                    token={this.props.token}
                    updateLocalExplanation={this.updateLocalExplanation}
                    updateTree={this.updateTree}
                    selectInstanceChange={this.selectInstanceChange}
                    selectInstanceChangeTest={this.selectInstanceChangeTest}
                />
              }
              {this.state.loading && !this.state.redirect &&(
            <div className={classes.loader}>
              {this.props.mode === "beginner" &&
              <StepperSimple
                  language={this.props.language}
                  initialValue={1}
                  gotoComparation={this.gotoComparation}
                  goToInitial = {this.goToInitial}
              />
              }
              <CircularProgress className={classes.progress} size={100} />
              <Typography variant="h3" align="center">
                {this.props.language.labels[this.props.language.id].loading}
              </Typography>
            </div>
        )}
        {!this.state.loading && !this.state.redirect &&(
            <Grid container className={classes.root}>
          {this.props.mode === "beginner" &&
          <StepperSimple
              language={this.props.language}
              initialValue={1}
              gotoComparation={this.gotoComparation}
              goToInitial = {this.goToInitial}
          />
          }

              <ExpansionPanel>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                  {this.state.percentageJ48 >= 80 && (
                      <Chip
                          className={classes.chipHigh}
                          color="primary"
                          icon={<High />}
                          label={
                            this.props.language.labels[this.props.language.id].precision +
                            ": " +
                            this.state.percentageJ48 +
                            "%"
                          }
                      />
                  )}
                  {this.state.percentageJ48 >= 60 &&
                  this.state.percentageJ48 < 80 && (
                      <Chip
                          className={classes.chipMedium}
                          color="primary"
                          icon={<Medium />}
                          label={
                            this.props.language.labels[this.props.language.id]
                                .precision +
                            ": " +
                            this.state.percentageJ48 +
                            "%"
                          }
                      />
                  )}
                  {this.state.percentageJ48 < 60 && (
                      <Chip
                          className={classes.chipLow}
                          color="primary"
                          icon={<Low />}
                          label={
                            this.props.language.labels[this.props.language.id].precision +
                            ": " +
                            this.state.percentageJ48 +
                            "%"
                          }
                      />
                  )}
                  <Typography variant="h4">J48</Typography>
                  <Popup trigger={
                    <IconButton
                        id={"J48"}
                        color="primary"  aria-label="upload picture" component="span"
                        className={classes.buttonInfo}
                    >
                     <InfoIcon/>
                    </IconButton>} modal >
                    <Card >
                      <CardHeader title={"Algorithm J48"} />
                      <CardMedia style ={{height:"300px"}}
                                 className={classes.media}
                                 image={tree1}
                                 title={"J48"}
                      />
                      <CardContent>
                        <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                          J48 is the implementation in Weka of the C4.5 algorithm first introduced by Quinlan. It is actually a pruned C4.5 classifier. This algorithm is deemed as an interpretable white box because traversing the tree from root to leaves it is possible to understand the classificaton of every single data instance.
                        </Typography>
                        <br/>
                        <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                          You can get further details in the following references:
                        </Typography>
                        <br/>
                        <Typography variant="body" color="textSecondary" component="list" style={{textAlign: "justify"}}>
                          <List>
                            <ListItem >
                              <ListItemIcon>
                                <FiberManualRecordIcon fontSize="small"/>
                              </ListItemIcon>
                              <ListItemText >
                                <Link target="_blank" href=" https://doi.org/10.1007/BF00116251">
                                  J. R. Quinlan, "Induction of decision trees", Machine learning, 1(1):81–106, 1986.
                                </Link>
                              </ListItemText>
                            </ListItem>
                            <ListItem>
                              <ListItemIcon>
                                <FiberManualRecordIcon fontSize="small"/>
                              </ListItemIcon>
                              <ListItemText  >
                                <Link target="_blank" href="https://www.cs.waikato.ac.nz/ml/weka/book.html">
                                  I. H. Witten, E. Frank, M. A. Hall, and C. J. Pal, "Data Mining: Practical machine learning tools and techniques", Morgan Kaufmann, 2016.
                                </Link>
                              </ListItemText>
                            </ListItem>
                          </List>
                        </Typography>
                      </CardContent>
                    </Card>
                  </Popup>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                      <Typography variant="h4">{this.props.language.labels[this.props.language.id].globalExplanation}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                        <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                        { this.state.globalExplanationJ48.map(item => {
                          return item + " ";
                        })}
                        </Typography>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                  {this.state.localExplanationJ48 &&
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                      <Typography variant="h4">{this.props.language.labels[this.props.language.id].localExplanation}</Typography>
                    </ExpansionPanelSummary>

                    <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                      <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                        {this.state.localExplanationJ48.map(item => {
                          return item + " ";
                        })}
                      </Typography>

                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                  }
                  <ExpansionPanel >
                    <ExpansionPanelSummary>
                      <Typography variant="h4">{this.props.language.labels[this.props.language.id].visualizeModel}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails style={{display:"block",marginTop:30}}>
                      {this.state.alternativesJ48 &&
                      <Fragment>
                      <AlternativesSelect
                        alternatives={this.state.alternativesJ48}
                        changeAlternative={this.changeAlternative}
                        />
                        <Tree
                        treeData={
                        this.state.alternativesJ48[this.state.alternativeIndex]
                      }
                        solution={
                        this.state.solutionsJ48[this.state.alternativeIndex]
                      }
                        />
                        </Fragment>
                      }
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                  {this.state.percentageREPTree >= 80 && (
                      <Chip
                          className={classes.chipHigh}
                          color="primary"
                          icon={<High />}
                          label={
                            this.props.language.labels[this.props.language.id].precision +
                            ": " +
                            this.state.percentageREPTree +
                            "%"
                          }
                      />
                  )}
                  {this.state.percentageREPTree >= 60 &&
                  this.state.percentageREPTree < 80 && (
                      <Chip
                          className={classes.chipMedium}
                          color="primary"
                          icon={<Medium />}
                          label={
                            this.props.language.labels[this.props.language.id]
                                .precision +
                            ": " +
                            this.state.percentageREPTree +
                            "%"
                          }
                      />
                  )}
                  {this.state.percentageREPTree < 60 && (
                      <Chip
                          className={classes.chipLow}
                          color="primary"
                          icon={<Low />}
                          label={
                            this.props.language.labels[this.props.language.id].precision +
                            ": " +
                            this.state.percentageREPTree +
                            "%"
                          }
                      />
                  )}
                  <Typography variant="h4">REPTree</Typography>
                  <Popup trigger={
                    <IconButton
                        id={"REPTree"}
                        color="primary"  aria-label="upload picture" component="span"
                        className={classes.buttonInfo}
                    >
                      <InfoIcon/>
                    </IconButton>} modal >
                    <Card >
                      <CardHeader title={"Algorithm REPTree"} />
                      <CardMedia style ={{height:"300px"}}
                                 className={classes.media}
                                 image={tree3}
                                 title={"REPTree"}
                      />
                      <CardContent>
                        <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                          REPTree is a variant of the C4.5 algorithm first introduced by Quinlan. It uses regression tree logic and creates multiple trees in different iterations. At the end, it selects the best tree among all the generated trees. This algorithm is considered as a white box because it produces as output a simple decision tree with the same format that J48.                                </Typography>
                        <br/>
                        <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                          You can get further details in the following references:
                        </Typography>
                        <br/>
                        <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                          <List>
                            <ListItem >
                              <ListItemIcon>
                                <FiberManualRecordIcon fontSize="small"/>
                              </ListItemIcon>
                              <ListItemText >
                                J. R. Quinlan, "Induction of decision trees", Machine learning, 1(1):81–106, 1986,&nbsp;
                                <Link target="_blank" href="https://doi.org/10.1007/BF00116251">
                                  https://doi.org/10.1007/BF00116251
                                </Link>
                              </ListItemText>
                            </ListItem>
                            <ListItem >
                              <ListItemIcon>
                                <FiberManualRecordIcon fontSize="small"/>
                              </ListItemIcon>
                              <ListItemText >
                                I. H. Witten, E. Frank, M. A. Hall, and C. J. Pal, "Data Mining: Practical machine learning tools and techniques", Morgan Kaufmann, 2016,&nbsp;
                                <Link target="_blank" href="https://www.cs.waikato.ac.nz/ml/weka/book.html">
                                  https://www.cs.waikato.ac.nz/ml/weka/book.html
                                </Link>
                              </ListItemText>
                            </ListItem>
                          </List>
                        </Typography>
                      </CardContent>
                    </Card>
                  </Popup>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                      <Typography variant="h4">{this.props.language.labels[this.props.language.id].globalExplanation}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                      <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                        { this.state.globalExplanationREPTree.map(item => {
                          return item + " ";
                        })}
                      </Typography>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                  {this.state.localExplanationREPTree &&

                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                      <Typography variant="h4">{this.props.language.labels[this.props.language.id].localExplanation}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                      <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                        {this.state.localExplanationREPTree.map(item => {
                          return item + " ";
                        })}
                      </Typography>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                  }
                  <ExpansionPanel >
                    <ExpansionPanelSummary>
                      <Typography variant="h4">{this.props.language.labels[this.props.language.id].visualizeModel}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails style={{display:"block",marginTop:30}}>
                      {this.state.alternativesREPTree &&
                      <Fragment>
                        <AlternativesSelect
                            alternatives={this.state.alternativesREPTree}
                            changeAlternative={this.changeAlternative}
                        />
                        <Tree
                            treeData={
                              this.state.alternativesREPTree[this.state.alternativeIndex]
                            }
                            solution={
                              this.state.solutionsREPTree[this.state.alternativeIndex]
                            }
                        />
                      </Fragment>
                      }
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                  {this.state.percentageRandomTree >= 80 && (
                      <Chip
                          className={classes.chipHigh}
                          color="primary"
                          icon={<High />}
                          label={
                            this.props.language.labels[this.props.language.id].precision +
                            ": " +
                            this.state.percentageRandomTree +
                            "%"
                          }
                      />
                  )}
                  {this.state.percentageRandomTree >= 60 &&
                  this.state.percentageRandomTree < 80 && (
                      <Chip
                          className={classes.chipMedium}
                          color="primary"
                          icon={<Medium />}
                          label={
                            this.props.language.labels[this.props.language.id]
                                .precision +
                            ": " +
                            this.state.percentageRandomTree +
                            "%"
                          }
                      />
                  )}
                  {this.state.percentageRandomTree < 60 && (
                      <Chip
                          className={classes.chipLow}
                          color="primary"
                          icon={<Low />}
                          label={
                            this.props.language.labels[this.props.language.id].precision +
                            ": " +
                            this.state.percentageRandomTree +
                            "%"
                          }
                      />
                  )}
                  <Typography variant="h4">RandomTree</Typography>
                  <Popup trigger={
                    <IconButton
                        id={"RandomTree"}
                        color="primary"  aria-label="upload picture" component="span"
                        className={classes.buttonInfo}
                    >
                      <InfoIcon/>
                    </IconButton>} modal >
                    <Card >
                      <CardHeader title={"Algorithm RandomTree"} />
                      <CardMedia style ={{height:"300px"}}
                                 className={classes.media}
                                 image={tree2}
                                 title={"RandomTree"}
                      />
                      <CardContent>
                        <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                          This is a variant of the C4.5 algorithm first introduced by Quinlan. It applies bagging to produce a random set of training data instances for the generation of several decision trees. At the end, similarly to REPTree, it provides users with only one individual tree model, and because of that it is also deemed as a white box.
                        </Typography>
                        <br/>
                        <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                          You can get further details in the following references:
                        </Typography>
                        <br/>
                        <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                          <List>
                            <ListItem >
                              <ListItemIcon>
                                <FiberManualRecordIcon fontSize="small"/>
                              </ListItemIcon>
                              <ListItemText >
                                <Link target="_blank" href="https://doi.org/10.1007/BF00116251">
                                  J. R. Quinlan, "Induction of decision trees", Machine learning, 1(1):81–106, 1986.&nbsp;
                                </Link>
                              </ListItemText>
                            </ListItem>
                            <ListItem >
                              <ListItemIcon>
                                <FiberManualRecordIcon fontSize="small"/>
                              </ListItemIcon>
                              <ListItemText >
                                <Link target="_blank" href="https://www.cs.waikato.ac.nz/ml/weka/book.html">
                                  I. H. Witten, E. Frank, M. A. Hall, and C. J. Pal, "Data Mining: Practical machine learning tools and techniques", Morgan Kaufmann, 2016.&nbsp;
                                </Link>
                              </ListItemText>
                            </ListItem>
                          </List>
                        </Typography>
                      </CardContent>
                    </Card>
                  </Popup>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                      <Typography variant="h4">{this.props.language.labels[this.props.language.id].globalExplanation}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                      <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                        { this.state.globalExplanationRandomTree.map(item => {
                          return item + " ";
                        })}
                      </Typography>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                  {this.state.localExplanationRandomTree &&
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                      <Typography variant="h4">{this.props.language.labels[this.props.language.id].localExplanation}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                      <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                        {this.state.localExplanationRandomTree.map(item => {
                          return item + " ";
                        })}
                      </Typography>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                  }
                  <ExpansionPanel >
                    <ExpansionPanelSummary>
                      <Typography variant="h4">{this.props.language.labels[this.props.language.id].visualizeModel}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails style={{display:"block",marginTop:30}}>
                      {this.state.alternativesRandomTree &&
                      <Fragment>
                        <AlternativesSelect
                            alternatives={this.state.alternativesRandomTree}
                            changeAlternative={this.changeAlternative}
                        />
                        <Tree
                            treeData={
                              this.state.alternativesRandomTree[this.state.alternativeIndex]
                            }
                            solution={
                              this.state.solutionsRandomTree[this.state.alternativeIndex]
                            }
                        />
                      </Fragment>
                      }
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                  {this.state.percentageHoeffdingTreeFuzzy >= 80 && (
                      <Chip
                          className={classes.chipHigh}
                          color="primary"
                          icon={<High />}
                          label={
                            this.props.language.labels[this.props.language.id].precision +
                            ": " +
                            this.state.percentageHoeffdingTreeFuzzy +
                            "%"
                          }
                      />
                  )}
                  {this.state.percentageHoeffdingTreeFuzzy >= 60 &&
                  this.state.percentageHoeffdingTreeFuzzy < 80 && (
                      <Chip
                          className={classes.chipMedium}
                          color="primary"
                          icon={<Medium />}
                          label={
                            this.props.language.labels[this.props.language.id]
                                .precision +
                            ": " +
                            this.state.percentageHoeffdingTreeFuzzy +
                            "%"
                          }
                      />
                  )}
                  {this.state.percentageHoeffdingTreeFuzzy < 60 && (
                      <Chip
                          className={classes.chipLow}
                          color="primary"
                          icon={<Low />}
                          label={
                            this.props.language.labels[this.props.language.id].precision +
                            ": " +
                            this.state.percentageHoeffdingTreeFuzzy +
                            "%"
                          }
                      />
                  )}
                  <Typography variant="h4">FuzzyHoeffdingDecisionTree</Typography>
                  <Popup trigger={
                    <IconButton
                        id={"FuzzyHoeffdingDecisionTree"}
                        color="primary"  aria-label="upload picture" component="span"
                        className={classes.buttonInfo}
                    >
                      <InfoIcon/>
                    </IconButton>} modal >
                    <Card >
                      <CardHeader title={"Algorithm FuzzyHoeffdingDecisionTree"} />
                      <CardMedia style ={{height:"300px"}}
                                 className={classes.media}
                                 image={rulesTree}
                                 title={"FuzzyHoeffdingDecisionTree"}
                      />
                      <CardContent>
                        <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                          A Fuzzy Hoeffding Decision Tree is a fuzzy decision tree, whose structure resembles a directed acyclic graph, with internal nodes representing
                          a test on a feature, branches denoting the outcome of the test, and terminal nodes (leaves) containing instances belonging to one or more class labels. It is actually a fuzzy extension of the original Hoeffding Decision Tree.
                        </Typography>
                        <br/>
                        <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                          You can get further details in the following references:
                          <List>
                            <ListItem >
                              <ListItemIcon>
                                <FiberManualRecordIcon fontSize="small"/>
                              </ListItemIcon>
                              <ListItemText >
                                <Link target="_blank" href="https://doi.org/10.2991/eusflat-19.2019.102">
                                  R. Pecori, P. Ducange, F. Marcelloni, "Incremental learning of fuzzy decision trees for streaming data classification", in 11th Conference of the European Society for Fuzzy Logic and Technology (EUSFLAT), Atlantis Press, 2019.&nbsp;
                                </Link>
                              </ListItemText>
                            </ListItem>
                            <ListItem >
                              <ListItemIcon>
                                <FiberManualRecordIcon fontSize="small"/>
                              </ListItemIcon>
                              <ListItemText >
                                Jose M. Alonso, Pietro Ducange, Riccardo Pecori, Raul Vilas, "Building Explainable Fuzzy Decision Trees with the ExpliClas Software", in IEEE International Conference on Fuzzy Systems (FUZZ-IEEE), Glasgow, Scotland, UK, pp. 1–8, 2020 &nbsp;
                              </ListItemText>
                            </ListItem>
                          </List>
                        </Typography>
                      </CardContent>
                    </Card>
                  </Popup>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                      <Typography variant="h4">{this.props.language.labels[this.props.language.id].globalExplanation}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                      <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                        { this.state.globalExplanationHoeffdingTreeFuzzy.map(item => {
                          return item + " ";
                        })}
                      </Typography>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                  {this.state.localExplanationHoeffdingTreeFuzzy &&
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                      <Typography variant="h4">{this.props.language.labels[this.props.language.id].localExplanation}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                      <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                        {this.state.localExplanationHoeffdingTreeFuzzy.map(item => {
                          return item + " ";
                        })}
                      </Typography>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                  }
                  <ExpansionPanel >
                    <ExpansionPanelSummary>
                      <Typography variant="h4">{this.props.language.labels[this.props.language.id].visualizeModel}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails style={{display:"block",marginTop:30}}>
                      {this.state.alternativesFuzzyHoeffdingDecisionTree &&
                      <Fragment>
                        <AlternativesSelect
                            alternatives={this.state.alternativesFuzzyHoeffdingDecisionTree}
                            changeAlternative={this.changeAlternative}
                        />
                        <Tree
                            treeData={
                              this.state.alternativesFuzzyHoeffdingDecisionTree[this.state.alternativeIndexHT]
                            }
                            solution={
                              this.state.solutionsFuzzyHoeffdingDecionTree[this.state.alternativeIndexHT]
                            }
                        />
                      </Fragment>
                      }
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                  {this.state.percentageFURIA >= 80 && (
                      <Chip
                          className={classes.chipHigh}
                          color="primary"
                          icon={<High />}
                          label={
                            this.props.language.labels[this.props.language.id].precision +
                            ": " +
                            this.state.percentageFURIA +
                            "%"
                          }
                      />
                  )}
                  {this.state.percentageFURIA >= 60 &&
                  this.state.percentageFURIA < 80 && (
                      <Chip
                          className={classes.chipMedium}
                          color="primary"
                          icon={<Medium />}
                          label={
                            this.props.language.labels[this.props.language.id]
                                .precision +
                            ": " +
                            this.state.percentageFURIA +
                            "%"
                          }
                      />
                  )}
                  {this.state.percentageFURIA < 60 && (
                      <Chip
                          className={classes.chipLow}
                          color="primary"
                          icon={<Low />}
                          label={
                            this.props.language.labels[this.props.language.id].precision +
                            ": " +
                            this.state.percentageFURIA +
                            "%"
                          }
                      />
                  )}
                  <Typography variant="h4">FURIA</Typography>
                  <Popup trigger={
                    <IconButton
                        id={"FURIA"}
                        color="primary"  aria-label="upload picture" component="span"
                        className={classes.buttonInfo}
                    >
                      <InfoIcon/>
                    </IconButton>} modal >
                    <Card >
                      <CardHeader title={"Algorithm FURIA"} />
                      <CardMedia style ={{height:"300px"}}
                                 className={classes.media}
                                 image={rules}
                                 title={"FURIA"}
                      />
                      <CardContent>
                        <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                          This stands for Fuzzy Unordered Rule Induction Algorithm. It generates fuzzy IF-THEN classification rules with fuzzy sets of trapezoidal shape in the antecedent of each rule. Such fuzzy sets lack of linguistic interpretability.
                        </Typography>
                        <br/>
                        <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                          FURIA is deemed as a gray-box classifier because it produces a set of rules which can be interpreted (at certain degree) by users. If there is no rule with activation degree greater than zero then FURIA offers to the user three options: 1) abstain (i.e., no output class is given); 2) voting for the a priori most frequent class in the dataset; and 3) rule stretching (i.e., a new set of rules is dynamically created from the initial rule base by removing antecedents in order one by one, rule by rule, until the instance is covered).
                        </Typography>
                        <br/>
                        <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                          You can get further details in the following references:
                          <List>
                            <ListItem >
                              <ListItemIcon>
                                <FiberManualRecordIcon fontSize="small"/>
                              </ListItemIcon>
                              <ListItemText >
                                <Link target="_blank" href="https://doi.org/10.1007/s10618-009-0131-8">
                                  J. Huhn and E. Hullermeier, "FURIA: an algorithm for unordered fuzzy rule induction", Data Mining and Knowledge Discovery, 19(3):293–319, 2009.&nbsp;
                                </Link>
                              </ListItemText>
                            </ListItem>
                          </List>
                        </Typography>
                        <br/>
                      </CardContent>
                    </Card>
                  </Popup>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                      <Typography variant="h4">{this.props.language.labels[this.props.language.id].globalExplanation}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                      <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                        { this.state.globalExplanationFURIA.map(item => {
                          return item + " ";
                        })}
                      </Typography>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                  {this.state.localExplanationFURIA &&
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                      <Typography variant="h4">{this.props.language.labels[this.props.language.id].localExplanation}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                      <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                        {this.state.localExplanationFURIA.map(item => {
                          return item + " ";
                        })}
                      </Typography>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                  }
                  <ExpansionPanel >
                    <ExpansionPanelSummary>
                      <Typography variant="h4">{this.props.language.labels[this.props.language.id].visualizeModel}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails style={{display:"block",marginTop:30}}>
                      {this.state.rulesFuria &&
                      <Fragment>
                        <Rules
                            rules={this.state.rulesFuria}
                            language={this.props.language}
                            comprobation={this.state.comprobation}
                        />
                      </Fragment>
                      }
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                  {this.state.percentageRandomForest >= 80 && (
                      <Chip
                          className={classes.chipHigh}
                          color="primary"
                          icon={<High />}
                          label={
                            this.props.language.labels[this.props.language.id].precision +
                            ": " +
                            this.state.percentageRandomForest +
                            "%"
                          }
                      />
                  )}
                  {this.state.percentageRandomForest >= 60 &&
                  this.state.percentageRandomForest < 80 && (
                      <Chip
                          className={classes.chipMedium}
                          color="primary"
                          icon={<Medium />}
                          label={
                            this.props.language.labels[this.props.language.id]
                                .precision +
                            ": " +
                            this.state.percentageRandomForest +
                            "%"
                          }
                      />
                  )}
                  {this.state.percentageRandomForest < 60 && (
                      <Chip
                          className={classes.chipLow}
                          color="primary"
                          icon={<Low />}
                          label={
                            this.props.language.labels[this.props.language.id].precision +
                            ": " +
                            this.state.percentageRandomForest +
                            "%"
                          }
                      />
                  )}
                  <Typography variant="h4">RandomForest</Typography>
                  <Popup trigger={
                    <IconButton
                        id={"RandomForest"}
                        color="primary"  aria-label="upload picture" component="span"
                        className={classes.buttonInfo}
                    >
                      <InfoIcon/>
                    </IconButton>} modal >
                    <Card >
                      <CardHeader title={"Algorithm RandomForest"} />
                      <CardMedia style ={{height:"300px"}}
                                 className={classes.media}
                                 image={forest}
                                 title={"RandomForest"}
                      />
                      <CardContent>
                        <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                          This is an ensemble learning method that creates a combination of C4.5 decision trees. Even though single classifiers are deemed as interpretable white boxes, their random combination is hardly interpretable and is considered as a black box.
                        </Typography>
                        <br/>
                        <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                          You can get further details in the following references:
                          <List>
                            <ListItem >
                              <ListItemIcon>
                                <FiberManualRecordIcon fontSize="small"/>
                              </ListItemIcon>
                              <ListItemText >
                                <Link target="_blank" href="https://doi.org/10.1023/A:1010933404324">
                                  L. Breiman, "Random forests", Machine Learning, 45(1):5–32, 2001.&nbsp;
                                </Link>
                              </ListItemText>
                            </ListItem>
                          </List>
                        </Typography>
                      </CardContent>
                    </Card>
                  </Popup>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                      <Typography variant="h4">{this.props.language.labels[this.props.language.id].globalExplanation}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                      <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                        { this.state.globalExplanationRandomForest.map(item => {
                          return item + " ";
                        })}
                      </Typography>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                  {this.state.localExplanationRandomForest &&
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                      <Typography variant="h4">{this.props.language.labels[this.props.language.id].localExplanation}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                      <Typography variant="body1" component="p" style={{textAlign: "justify"}}>
                        {this.state.localExplanationRandomForest}
                      </Typography>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                  }
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </Grid>
        )}
            </Paper>
          </Grid>
          <footer className={classes.footer}>
            <Grid container direction="row" alignItems="center" justify={"center"}>
              <Grid  className={classes.centerFotter} item xs={12} md={8} lg={8} >
                <img
                    src={galicia}
                    alt="logo turístico galicia"
                    className={classes.leftLogos}
                />
                <img
                    src={xacobeo}
                    alt="logo xacobeo 2021"
                    className={classes.leftLogos}
                />
                <img src={citius_horizontal} alt="logo citius" className={classes.leftLogos} />
                <img src={usc} alt="logo usc" className={classes.leftLogos} />
                <img
                    src={campusVida}
                    alt="logo campus vida"
                    className={classes.leftLogos}
                />
              </Grid>
              <Grid className={classes.centerFotter}  item xs={12} md={4} lg={4} >
                <img
                    src={ue}
                    alt="logo unión europea"
                    className={classes.rightLogos}
                />
                <img
                    src={xunta}
                    alt="logo xunta de galicia"
                    className={classes.rightLogos}
                />
              </Grid>
            </Grid>
            <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "center"}}>
              {this.props.language.labels[this.props.language.id].fondoEuropeo}
            </Typography>
          </footer>
        <CustomizedSnackbars
          openInfo={this.state.info}
          openFail={this.state.error}
          handleClose={this.handleClose}
          message={this.state.message}
        />
        {(!this.props.token || this.state.redirect) && <Redirect to="/datasets" />}
        {!this.props.dataset && <Redirect to="/datasets" />}
        {this.state.redirectComparation  && <Redirect to="/algorithmsComparation" />}
        </Grid>
      </Fragment>
    );
  }
}

ClassifierPanelAll.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ClassifierPanelAll);
